<div class="card activity-card">
  <div>
    <div [class.activity-card__unplanned]="isUnplanned()" [class.success]="noMessages()" class="activity-card__header">
      <svg-icon class="" src="assets/images/icons/{{ boxIcon() }}.svg"></svg-icon>
      <h2>{{ boxTitle() | translate }}</h2>
    </div>
    @if (noMessages()) {
      <div>
        <div class="activity-card__empty-state">
          <svg-icon class="activity-card__empty-state--icon" src="assets/images/icons/icon-rocket.svg"></svg-icon>
          <span class="activity-card__empty-state--text">{{ "Subscription.Message.NoError" | translate }}</span>
        </div>
      </div>
    } @else {
      <div>
        <ul>
          @for (message of messages() | slice: 0 : 3; track $index) {
            <li class="activity-card__item" (click)="openDialog(message)">
              <span class="activity-card__message"> {{ message.heading }} </span>
              <span class="activity-card__time">
                {{ message.startDate | date: "d MMM" }}, {{ message.startDate | date: "HH:mm" }}
                {{ "Global.Until" | translate }} {{ message.endDate | date: "HH:mm" }}
              </span>
            </li>
          }
        </ul>
        <div class="activity-card__footer">
          <a [routerLink]="['/storing-en-onderhoud']">
            <span>{{ "Overview.RecentMessages.Follow" | translate }}</span>
          </a>
        </div>
      </div>
    }
  </div>
</div>
